
import { Close } from '@material-ui/icons'
import React from 'react'

import styles from './StatusPopup.module.scss'
interface Props {
 handleClose: any;
timeContent:any;
reasonContent:any;
btnSubmit:any;
pauseReason:any;
pauseDuration:any;
timeValidation?:boolean,
reasonValidation?:boolean

}


const StatusPopup: React.FC<Props> = ({handleClose,timeContent,btnSubmit,reasonContent,pauseDuration,pauseReason,timeValidation,reasonValidation})=> {



    return (
        <div className={styles.popup_box}>
      <div className={styles.box}>
        <span className={styles.close_icon} onClick={handleClose}><Close/></span>
        <div className={styles.popup_header}>
          
          Pause your store for: <b style={{color:"red"}}>{pauseDuration}</b>
        </div>
        <div className={styles.radio_button_container_reason}>
        {timeContent}  
        </div>
 <div className={styles.popup_header}>
          Reason for pause:<b style={{color:"red"}}> {pauseReason}</b>
        </div>
        <div className={styles.radio_button_container_two}>
        {reasonContent}  
        </div>
        
        
        <button className={styles.btn__submit} onClick={btnSubmit} disabled={timeValidation && reasonValidation ? false : true}>Pause store</button>
        
        
      </div>
    </div>
    )
}

export default StatusPopup
